module.exports = __webpack_public_path__ + "img/UTQUAI-9.4d1a6314.jpg";